// extracted by mini-css-extract-plugin
module.exports = {"switcher":"styles_switcher__3l_qP","switcher--label":"styles_switcher--label__21cjm"};